import { render, staticRenderFns } from "./PensionByAge.vue?vue&type=template&id=15d3cb22&scoped=true&"
import script from "./PensionByAge.vue?vue&type=script&lang=js&"
export * from "./PensionByAge.vue?vue&type=script&lang=js&"
import style0 from "./PensionByAge.vue?vue&type=style&index=0&id=15d3cb22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3cb22",
  null
  
)

export default component.exports